import React from "react";

import IndividualExperience from "./IndividualExperience";
import Listing from "../Listing/Listing";

const ExperienceListing = () => {
  const experiences = [
    {
      from: "July 2019",
      to: "May 2020",
      company: "KLASS Engineering & Solutions",
      position: "Software Engineer (Video Analytics)",
      type: "Internship",
      description:
        "Contributed to the building of an end-to-end machine learning platform that streamlined the entire model development lifecycle—enabling data scientists to label, train, evaluate, and deploy computer vision models through a unified web interface.",
      stack: [
        "React",
        "Docker",
        "Python",
        "Go",
        "AntDesign",
        "Cypress",
        "Redis",
      ],
    },
    {
      from: "May 2022",
      to: "August 2022",
      company: "KLASS Engineering & Solutions",
      position: "Software Engineer (Video Analytics)",
      type: "Contract",
      description:
        "Contributed to the building of a production-ready person reidentification system using Milvus vector database, deploying via Kubernetes (k3s) for scalable, edge-ready video analytics in secure, air-gapped environments.",
      stack: [
        "Kubernetes",
        "Docker",
        "Python",
        "Machine Learning",
        "Milvus"
      ],
    },
    {
      from: "August 2023",
      to: "April 2024",
      company: "Singapore Management University",
      position: "COR-IS1702: Computational Thinking Teaching Assistant",
      type: "Contract",
      description:
        "Facilitated learning for 50+ students across two semesters, providing mentorship on data structures, algorithms, and computational problem-solving techniques.",
      stack: [],
    },
    {
      from: "May 2024",
      to: "December 2024",
      company: "Accenture (Southeast Asia)",
      position: "Software Engineer",
      type: "Internship",
      description:
        "Contributed to the cloud migration of a government-scale disbursement platform, building batch processing microservices with Spring Boot and AWS to modernise legacy infrastructure and improve service reliability.",
      stack: [
        "Spring Boot",
        "Spring Batch",
        "AWS"
      ],
    },
    {
      from: "Jan 2025",
      to: "Jun 2025",
      company: "Government of Singapore Investment Corporation (GIC)",
      position: "Software Engineer",
      type: "Internship",
      description:
        "Contributed to trading automation tools within the Portware execution management system, reducing manual workflows for portfolio traders and improving execution efficiency through custom Java-based order routing functionalities.",
      stack: [
        "Java",
        "Portware",
        "AWS"
      ],
    },
    {
      from: "Jun 2025",
      to: "Jan 2026",
      company: "TikTok",
      position: "Software Engineer",
      type: "Internship",
      description:
        "Developed core backend services for the LIVE Wallet platform, powering real-time transaction processing for millions of users across TikTok's live streaming ecosystem.",
      stack: [
        "Go",
        "TypeScript",
      ],
    },
    {
      from: "Jan 2026",
      to: "May 2026",
      company: "Singapore Management University",
      position: "CS301: IT Solutions Architecture Teaching Assistant",
      type: "Contract",
      description:
        "Guiding 50+ students through hands-on AWS infrastructure design, teaching cloud architecture best practices and supporting practical labs on solution design, scalability, and security.",
      stack: [],
    },
    {
      from: "Jun 2026",
      to: "Current",
      company: "TikTok",
      position: "Software Engineer",
      type: "Full-time",
      description:
        "Backend Software Engineer Graduate.",
      stack: [],
    },
  ];

  return (
    <Listing
      list={experiences}
      title={"Experiences"}
      eyebrow="Career path"
      description="Recent roles across product engineering, cloud delivery, and teaching support, ordered from most recent to earlier foundational work."
      Component={IndividualExperience}
    />
  );
};

export default ExperienceListing;
